"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditedPaths = void 0;
var getEditedPaths = function (oldStructPaths, newStructPaths) {
  var diffs = [];
  for (var key in oldStructPaths) {
    if (newStructPaths.hasOwnProperty(key)) {
      if (typeof oldStructPaths[key] === 'object' && typeof newStructPaths[key] === 'object' && JSON.stringify(oldStructPaths[key]) === JSON.stringify(newStructPaths[key])) {
        continue;
      }
      if (oldStructPaths[key] !== newStructPaths[key]) {
        diffs.push([key, oldStructPaths[key], newStructPaths[key]]);
      }
    }
  }
  return diffs;
};
exports.getEditedPaths = getEditedPaths;